import { Badge } from "@/components/shadcn/badge";
import { cn } from "@/lib/utils";
import type { SecretScope } from "./useSecretsSources";

export function VariableScopeBadge({
  scope,
  size = "default",
  className,
}: {
  scope: SecretScope;
  size?: "default" | "sm";
  className?: string;
}) {
  return (
    <Badge
      variant={scope === "flow" ? "color-slate" : "color-sky"}
      className={cn(size === "sm" && "px-1.5 py-0 text-[10px]", className)}
    >
      {scope === "flow" ? "Flow" : "Workspace"}
    </Badge>
  );
}
